/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit InputSmall.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import Input from 'DesignSystem/Input/logic.js'
import React from 'react'
Input.displayName = 'InputLogic'



export default function InputSmall({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  autoComplete,
autoFocus,
backgroundColor= "#f2f2f2",
borderBottomLeftRadius= 5,
borderBottomRightRadius= 5,
borderTopLeftRadius= 5,
borderTopRightRadius= 5,
className,
disabled,
fontSize= 14,
height,
innerRef,
invalidMessage,
isInteger,
isInvalid,
label,
marginBottom,
marginLeft,
marginRight,
marginTop,
max,
min,
onBlur,
onChange,
onCopy,
onFocus,
onKeyDown,
onPaste,
onSubmit,
paddingBottom= 7,
paddingLeft= 8,
paddingRight= 8,
paddingTop= 7,
placeholder,
textTransform,
type,
value,
width= 200
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<Input
 data-testid="InputSmall.Input"
 data-view-path={dataViewPath}
 autoComplete={autoComplete}
 autoFocus={autoFocus}
 backgroundColor={backgroundColor}
 borderBottomLeftRadius={borderBottomLeftRadius}
 borderBottomRightRadius={borderBottomRightRadius}
 borderTopLeftRadius={borderTopLeftRadius}
 borderTopRightRadius={borderTopRightRadius}
 className={className}
 disabled={disabled}
 fontSize={fontSize}
 height={height}
 innerRef={innerRef}
 invalidMessage={invalidMessage}
 isInteger={isInteger}
 isInvalid={isInvalid}
 label={label}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
 marginTop={marginTop}
 max={max}
 min={min}
 onBlur={onBlur}
 onChange={onChange}
 onCopy={onCopy}
 onFocus={onFocus}
 onKeyDown={onKeyDown}
 onPaste={onPaste}
 onSubmit={onSubmit}
 paddingBottom={paddingBottom}
 paddingLeft={paddingLeft}
 paddingRight={paddingRight}
 paddingTop={paddingTop}
 placeholder={placeholder}
 textTransform={textTransform}
 type={type}
 value={value}
 width={width}
 className={className}
/>
{children}
</React.Fragment>)
}